import React from "react";
import { Box } from "@mui/material";

const Watermark = ({ text = "XSM DEMO" }) => {
  // Create a repeating pattern by rendering multiple text elements
  const createWatermarkGrid = () => {
    const watermarks = [];
    // Adjust these numbers to control the density of the pattern
    for (let i = -2; i < 4; i++) {
      for (let j = -2; j < 4; j++) {
        watermarks.push(
          <Box
            key={`${i}-${j}`}
            sx={{
              position: "absolute",
              left: `${j * 25}%`,
              top: `${i * 25}%`,
              fontFamily: "Anton, sans-serif",
              fontSize: {
                xs: "50px",
                sm: "60px",
                md: "80px",
              },
              color: "rgba(255, 255, 255, 0.14)",
              whiteSpace: "nowrap",
              transform: "rotate(-30deg)",
              userSelect: "none",
              transition: "font-size 0.3s ease",
            }}
          >
            {text}
          </Box>
        );
      }
    }
    return watermarks;
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        opacity: 1,
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      {createWatermarkGrid()}
    </Box>
  );
};

export default Watermark;
